import gql from "graphql-tag";

export const OPTION_PENDING_MODERATION_QUERY = gql`
  query OptionPendingModeration {
    option: optionPendingModeration {
      id
      product {
        id
        sourceName
        sourceUrl
      }
      entities {
        id
        entity
        value
      }
      aliexpressPullingImages {
        id
        imageUrl
        parentImageId
        optionValue
      }
    }
  }
`;

export {
  OptionPendingModeration,
  OptionPendingModeration_option as IOption,
  OptionPendingModeration_option_entities as IOptionEntity,
  OptionPendingModeration_option_aliexpressPullingImages as IAliExpressPullingImage,
  OptionPendingModeration_option_product as IProduct
} from "~/graphql/types";



// WEBPACK FOOTER //
// ./src/graphql/queries/aliexpress/optionPendingModeration.ts